<template>
  <div :class="['expanded-block__container', openState, browserState, fullscreenState, mobileState]">
    <div class="expanded-block stationStyle" v-if="$store.state.routing.expandedBlock.blockId">
      <div class="left">
        <div class="fullscreen-details top-right">
          <button @click="toggleFullscreen">Details</button>
          &nbsp;
          <button @click="closeBlock">Back</button>
        </div>
        <div class="fullscreen-details bottom-left">
          <p>{{ this.block.title }}</p>
        </div>
        <div class="fullscreen-details bottom-right">
          <p class="dont-select">
            <span class="arrow arrow-left" @click="moveBack">
              <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 11L1 6L6 1" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            {{ blockCountLabel }}
            <span class="arrow arrow-right" @click="moveNext">
              <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L1 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </p>
        </div>
        <BlockMaterial :block="block" :expanded="true"></BlockMaterial>
      </div>
      <div class="right">
        <div class="top">
          <p></p>
          <div class="actions-container">
            <button @click="toggleFullscreen">Fullscreen</button>
            &nbsp;
            <button class="shadow" @click="closeBlock">Back</button>
          </div>
        </div>
        <div class="details">
          <Editable tag="h3" keyName="title" :value="titleLabel" :blockId="block.id" >
          </Editable>
          <Editable tag="p" keyName="description" :value="descriptionLabel" :blockId="block.id" >
          </Editable>
          <br>
          <p class="uploader">Added by {{ block.uploader }}</p>
          <a v-if="block.format == 'Embed' && block.embed.style == 'PDF'" :href="block.embed.url" target="_blank">Open PDF</a>
          <a v-if="block.format == 'Image'" :href="block.image.url" target="_blank">Open Image</a>
        </div>
        <div class="metadata">
          <p>In Concept</p>
          <div class="connection" v-for="(conceptId, index) in block.concepts" :key="index">
            <div class="row">
              <div>{{ getConceptName(conceptId) }}</div>
              <button @click="toggleRemovingBlock(conceptId)">{{ removeBlockLabel(conceptId) }}</button>
            </div>
            <div class="row">
              <div v-if="startRemovingId == conceptId">
                <br>
                Remove from Concept? <button @click="removeBlock(conceptId)" class="delete">Confirm</button>
              </div>
            </div>
          </div>
        </div>
        <div class="metadata">
          <p>Type: {{ topLabel }}</p>
          <br>
          <button @click="startTogglingType">{{ toggleTypeLabel }}</button>
          <div v-if="togglingType == true">
            <br>
            Change to {{ typeChangingTo }}? <button class="primary" @click="confirmToggleType">Confirm</button>
          </div>
        </div>

        <div class="metadata" v-if="block.arenaId != undefined">
          <p>Pipes</p>
          <a :href="arenaBlockLink" target="_blank" rel="noopener">View Are.na Block</a>
        </div>

        <!--<div v-if="block.format == 'Hyperlink'" class="metadata">
          <p>{{ block.hyperlink.url }}</p>
          <p><a :href="block.hyperlink.url" target="_blank">Open link in new tab</a></p>
        </div>-->

        <div class="right-bottom">
          <p>{{ blockCountLabel }}</p>
          <button @click="toggleBrowser">{{ toggleBrowserLabel }}</button>
        </div>

        <!--<div v-if="block.format == 'Embed'" class="metadata">
          <p>{{ block.embed.url }}</p>
          <p><a :href="block.embed.url" target="_blank">Open embed in new tab</a></p>
        </div>-->

      </div>

    </div>
    <div class="browser__container">
      <div :class="['browser', 'stationStyle']">
        <!--<transition name="switchView" mode="out-in">-->
          <Block v-for="(relevantBlock, index) in relevantBlocks" :key="index" @click="setExpandedBlock(relevantBlock)" :block="relevantBlock" summary="summary" :isSelected="isSelected(relevantBlock)"></Block>
          <!-- <p><span v-if="relevantBlock.id == block.id">[</span>{{ relevantBlock.title }}<span v-if="relevantBlock.id == block.id">]</span></p> -->
        <!--</transition>-->
      </div>
    </div>
  </div>
</template>

<script>
import BlockMaterial from '@trust/components/BlockMaterial.vue'
import Editable from '@trust/components/Editable.vue'
import Block from '@trust/components/Block.vue'

   export default {
      name: 'BlockExpanded',
      components: {
        BlockMaterial,
        Editable,
        Block,
      },
      data(){
         return {
           startRemovingId: null,
           togglingType: false,
           showBrowser: false,
           isFullscreen: false,
         }
      },
      computed: {
        openState(){
          if(this.$store.state.routing.expandedBlock.open == true){
            return 'show';
          } else {
            return '';
          }
        },
        block(){
          let blockId = this.$store.state.routing.expandedBlock.blockId;
          let block = this.$store.state.org.blocks.find(b => b.id == blockId);
          return block;
        },
        concept(){
          let conceptId = this.$store.state.routing.expandedBlock.conceptId;
          let concept = this.$store.state.org.concepts.find(c => c.id == conceptId);
          return concept;
        },
        relevantBlocks(){
          if(!this.block){ return [] }
          let conceptId = this.$store.state.routing.expandedBlock.conceptId;
          let type = this.block.type;
          let blocks = this.$store.state.org.blocks.filter(b => b.type && b.type == type && b.concepts.includes(conceptId));
          blocks.sort(function(a, b) {
            if (a.createdAt > b.createdAt) return -1;
            if (a.createdAt < b.createdAt) return 1;
            return 0;
          });
          return blocks;
        },
        titleLabel(){
          return this.block.title || 'Add title';
        },
        descriptionLabel(){
          return this.block.description || 'Add description';
        },
        topLabel(){
          let label = this.block.type;
          return label;
        },
        toggleTypeLabel(){
          if(this.togglingType){
            return 'Cancel';
          }

          if(this.block.type == 'Idea'){
            return 'Change to Reference';
          } else {
            return 'Change to Idea';
          }
        },
        typeChangingTo(){
          if(this.block.type == 'Idea'){
            return 'Reference';
          } else {
            return 'Idea';
          }
        },
        editingId(){
          if(this.block){
            return this.block.id + '-' + 'type';
          } else {
            return 'no-block-yet';
          }
        },
        editingResult(){
          if(this.$store.state.trust.editingIds[this.editingId]) {
            return this.$store.state.trust.editingIds[this.editingId].result;
          } else {
            return null;
          }
        },
        browserState(){
          return (this.showBrowser) ? 'with--browser' : '';
        },
        toggleBrowserLabel(){
          return (this.showBrowser) ? 'Hide browser' : 'Show browser';
        },
        fullscreenState(){
          return (this.isFullscreen) ? 'is--fullscreen' : '';
        },
        mobileState(){
          return (this.isMobile()) ? 'is--mobile' : '';
        },
        currentBlockIndex(){
          let blockIndex = '';
          this.relevantBlocks.forEach((b, index) => {
            if(b.id == this.block.id){
              blockIndex = index;
              return;
            }
          })
          return blockIndex;
        },
        blockCountLabel(){
          let currentIndex = this.currentBlockIndex;
          let blockCount = this.relevantBlocks.length;
          let blockNumber = blockCount - currentIndex;
          return this.block.type + ' ' + blockNumber + '/' + blockCount;
        },
        arenaBlockLink(){
          return 'https://are.na/block/' + this.block.arenaId;
        }
      },
      mounted() {
        window.addEventListener('keydown', this.handleKeyDown);
      },
      destroyed(){
        window.removeEventListener('keydown', this.handleKeyDown);
      },
      methods:{
        closeBlock(){
          this.$store.dispatch('routing/closeBlock');
          this.startRemovingId = null;
        },
        removeBlock(conceptId){
          this.$store.dispatch('removeBlock', { blockId: this.block.id, conceptId: conceptId })
        },
        getConceptName(conceptId){
          let concept = this.$store.state.org.concepts.find(c => c.id == conceptId);
          return concept.name;
        },
        removeBlockLabel(conceptId){
          if(conceptId == this.startRemovingId) {
            return 'Cancel'
          } else {
            return 'Remove'
          }
        },
        toggleRemovingBlock(conceptId){
          if(conceptId == this.startRemovingId) {
            this.startRemovingId = null;
          } else {
            this.startRemovingId = conceptId;
          }
        },
        moveBack(){
          let newIndex = this.currentBlockIndex - 1;
          if(newIndex < 0) { newIndex = 0; }
          this.setExpandedBlock( this.relevantBlocks[newIndex] )
        },
        moveNext(){
          let newIndex = this.currentBlockIndex + 1;
          if(newIndex > this.relevantBlocks.length) { newIndex = this.relevantBlocks.length; }
          this.setExpandedBlock( this.relevantBlocks[newIndex] )
        },
        startTogglingType(){
          if(this.togglingType){
            this.togglingType = false;
          } else {
            this.togglingType = true;
          }
        },
        confirmToggleType(){
          // this.$store.dispatch('updateBlock', { blockId: this.block.id, conceptId: conceptId })
          this.$store.commit('updateBlock', { blockId: this.block.id, keyName: 'type', newValue: this.typeChangingTo, editingId: this.editingId });
        },
        toggleBrowser(){
          this.showBrowser = !this.showBrowser;
        },
        toggleFullscreen(){
          this.isFullscreen = !this.isFullscreen;

          if(this.isFullscreen){
            this.showBrowser = false;
          }
        },
        setExpandedBlock(block){
          this.$store.dispatch('routing/openBlock', { blockId: block.id, conceptId: this.$store.state.routing.expandedBlock.conceptId });
        },
        isSelected(relevantBlock){
          return (relevantBlock.id == this.block.id) ? 'is--selected' : '';
        },
        handleKeyDown(e) {
          // 37	left arrow
          // 38	up arrow
          // 39	right arrow
          // 40	down arrow
          if(this.$store.state.routing.expandedBlock.open == true){

            if(e.keyCode === 38 || e.keyCode === 37) {
              // move up
              this.moveBack();

            } else if(e.keyCode === 40 || e.keyCode === 39) {
              // move down
              this.moveNext();

            }
          }
        },
        isMobile(){
          if(window.innerWidth <= 600){
            return true;
          } else {
            return false;
          }
        },
     },
     watch: {
       '$store.state.org.removingStatus' (to) { // can also be (to, from)
         if(to == 'done' && this.$store.state.routing.expandedBlock.open == true) {
           this.closeBlock();
         }
       },
       'editingResult' (to) {
         if(to == 'success'){
           this.$store.commit('fetchBlocks');
           this.togglingType = false;

           this.successClass = 'editSuccess';
           setTimeout(function(){
             this.successClass = '';
           }.bind(this), 300);
         }
       }
     },
   }
</script>

<style>

.expanded-block__container {
  position: absolute;
  z-index: 10000;
  transition: var(--transition-base), background 0ms ease-in-out;
  transform-origin: center center;
  padding: 10px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  pointer-events: none;
  opacity: 0;
  transform: scale(0.95);
}

.expanded-block__container.show {
  pointer-events: all;
  opacity: 1;
  transform: scale(1);
}

.stationStyle {
  box-sizing: border-box;
  background: var(--beige-300);
  border: var(--border-station);
  transition: var(--transition-base);
}

.browser__container {
  height: 100%;
  width: 0;
  right: 0;
  box-sizing: border-box;
  transition: var(--transition-base);
  background: var(--beige-400);
}

.expanded-block__container .browser {
  height: 100%;
  width: 100%;
  border: 0;
  overflow-y: scroll;
}

.expanded-block {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 30vw;
  transition: var(--transition-base);
}

.expanded-block__container.with--browser .browser__container {
  width: calc(2 / 9 * 100%); /* smallSize */
  padding-left: 10px;
}

.expanded-block__container.with--browser .browser {
  border: var(--border-station);
}

.expanded-block__container.with--browser .expanded-block {
  width: calc(7 / 9 * 100%); /* largeSize */
  /* grid-template-columns: 1fr 20vw; */
}

.expanded-block__container.is--fullscreen .expanded-block {
  grid-template-columns: 1fr 0;
}

.expanded-block__container.is--fullscreen .expanded-block .right {
  opacity: 0;
  pointer-events: none;
  display: none;
}

.expanded-block .left {
  padding: 15px;
  padding-right: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100vh - 20px - 4px);
}

.expanded-block .left .fullscreen-details {
  display: none;
  position: absolute;
  z-index: 10;
}

.expanded-block .left .fullscreen-details.top-right {
  right: 10px;
  top: 8px;
  text-align: right;
}

.expanded-block .left .fullscreen-details.bottom-left {
  left: 12px;
  bottom: 12px;
}

.expanded-block .left .fullscreen-details.bottom-left p {
  background: var(--beige-300);
  padding: 8px;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 50vw;
}

.expanded-block .left .fullscreen-details.bottom-right {
  right: 12px;
  bottom: 12px;
  text-align: right;
}

.expanded-block .left .fullscreen-details.bottom-right p {
  background: var(--beige-300);
  padding: 8px;
  margin: 0;
}

.expanded-block__container.is--fullscreen .expanded-block .left .fullscreen-details {
  display: block;
}

.expanded-block__container.is--mobile {
  overflow: hidden;
  height: var(--mobile-top-fullscreen-height);
  border-radius: var(--mobile-border-radiuses);
}

.expanded-block__container.is--mobile .expanded-block .left .fullscreen-details .top-right {
  display: none;
}

.expanded-block__container.is--mobile .expanded-block .left {
  height: 65vh;
  margin-top: 32px;
}

.expanded-block__container.is--mobile.is--fullscreen .expanded-block .left {
  height: 85vh;
}

.expanded-block__container.is--mobile .expanded-block .right .top {
  position: absolute;
  text-align: right;
  padding: 0;
  right: 10px;
  top: 8px;
}

.expanded-block__container.is--mobile .expanded-block .right .top .actions-container {
  /* display: flex; */
}

.expanded-block__container.is--mobile .expanded-block .right {
  padding-left: 15px;
  padding-bottom: 40px;
}

.expanded-block__container.is--mobile .expanded-block .right .right-bottom {
  display: none;
}

.expanded-block__container.is--mobile .expanded-block .left .fullscreen-details.bottom-left p {
  border-bottom-left-radius: 20px;
}

.expanded-block__container.is--mobile .expanded-block .left .fullscreen-details.bottom-right p {
  border-bottom-right-radius: 20px;
}

.expanded-block .right {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
}

.expanded-block .right .right-bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: auto;
  margin-top: auto;
  padding: 0 15px 15px 0;
}

.expanded-block .right p {
  margin: 0;
  padding-right: 15px;
}

.expanded-block .right .top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 14px 10px 0px 0px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.expanded-block .details {
  margin-top: 40px;
  overflow-wrap: anywhere;
  padding-right: 15px;
}

.expanded-block .details h3,
.expanded-block .details p {
  font-size: 20px;
  line-height: 150%;
}

.expanded-block .details a {
  display: block;
  margin-top: 4px;
  color: var(--beige-700);
}

.expanded-block .details .uploader {
  font-family: 'Lettera', monospace;
  line-height: 150%;
  font-weight: 400;
  font-size: 16px;
}

.expanded-block .metadata {
  border-top: var(--border-station);
  padding-top: 20px;
  margin-top: 20px;
}

.expanded-block .metadata a {
  color: var(--beige-700);
  text-decoration: none;
}

.expanded-block .metadata a:hover {
  color: var(--black-1000);
}

.expanded-block .connection {
  border: 1px solid var(--beige-500);
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  font-size: 14px;
  margin-top: 15px;
}

.expanded-block .connection .row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.dont-select {
  user-select: none;
}

.arrow {

}

.arrow.arrow-left {
  margin-right: 8px;
}

.arrow.arrow-right {
  margin-left: 8px;
}

.arrow:hover {
  cursor: pointer;
  opacity: 0.6;
}


@media (max-device-width: 600px) {
  .expanded-block {
    grid-template-columns: none;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    overflow-x: hidden;
    border-radius: var(--mobile-border-radiuses);
  }

  .expanded-block .details {
    margin-top: 20px;
  }
}

</style>
